import type { ObjectValues } from '@/types';

export const QUERY_KEYS = {
  paywall: 'paywall',
  cuInfo: 'cuInfo',
  dataPreparerDownloadStatus: 'dataPreparerDownloadStatus',
  dataPreparerInfo: 'dataPreparerInfo',
  ariaFilesIsEmpty: 'ariaFilesIsEmpty',
  cdfiStatsData: 'cdfiStatsData',
  cdfiChartData: 'cdfiChartData',
  submissions: 'submissions',
  cdfiLoanChartData: 'cdfiLoanChartData',
  cdfiLoanStatsData: 'cdfiLoanStatsData',
} as const;

export type QueryKeys = ObjectValues<typeof QUERY_KEYS>;
